/* eslint-disable react-hooks/exhaustive-deps */
import {
  Skeleton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { useDispatch, useSelector } from "react-redux";
import { fetchAggregatorData, fetchTableColumnData } from 'store';
import DataWorkbenchChat from "../DataWorkbenchChat/DataWorkbenchChat";
import SimpleTable from "../SimpleTable/SimpleTable";
// import classes from "./DataWorkbench.module.scss";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import DownloadIcon from "@mui/icons-material/Download";
import { exportToCSV } from '../../utils/exportToCSV';

import EntityRelationshipDiagram from './EntityRelationshipDiagram';

import Grid from '@mui/material/Grid';
// import SettingsIcon from '@mui/icons-material/Settings';
// import IconButton from '@mui/material/IconButton';
// import KnowledgeBaseSync from './KnowledgeBaseSync';
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  // height: '-webkit-fill-available',
  boxShadow: 'none',
  padding: theme.spacing(1),
  height: '100%'
  // ...theme.typography.body2,
  // textAlign: 'center',
  // color: (theme.vars ?? theme).palette.text.secondary,
  // ...theme.applyStyles('dark', {
  //   backgroundColor: '#1A2027',
  // }),
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const DataWorkbench = () => {
  const dispatch = useDispatch();
  const {
    dataset,
    tableColumnData,
    defaultQuery,
  } = useSelector((state) => state.aggregator);

  const [value, setValue] = useState(0);
  const sqlQuery = useSelector((state) => state.aggregator.sqlQuery);
  const userInput = useSelector((state) => state.aggregator.userInput);

  // Snackbar state
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbar({ ...snackbar, open: false });
  };

  // ...existing code...

  const handleChange = (event, newValue) => {
    setValue(newValue);
  }

  // Fetching the table column data
  const fetchData = async () => {
    await dispatch(fetchTableColumnData());
  }

  // For fetching the aggregator data along with the line chart data
  const fetchAggregator = async () => {
    try {
      await dispatch(fetchAggregatorData({ userInput, sqlQuery }));
    }
    catch (error) {
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (sqlQuery) {
      fetchAggregator();
      fetchData();
    }
  }, [sqlQuery]);

  return (
    <>
      <Grid container spacing={1} sx={{ height: `100%`, paddingBottom: '8px' }} >

        <Grid size={6} sx={{ height: `100%` }} >
          <Item >
            {!tableColumnData ? (
              <>
                <Skeleton variant="text" width="100%" height={30} />
                <Skeleton variant="text" width="100%" height={30} />
                <Skeleton variant="text" width="100%" height={30} />
              </>
            ) : (
              <DataWorkbenchChat
                defaultQuery={defaultQuery}
              />
            )}
          </Item>
        </Grid>

        <Grid size={6} sx={{ height: `100%` }}>
          <Item style={{ position: 'relative', height: '50%', display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
            <Typography variant="h6" gutterBottom>
              ER Diagram
            </Typography>
            <div style={{ flex: 1, minHeight: 0 }}>
              <EntityRelationshipDiagram tableColumnData={tableColumnData} />
            </div>
          </Item>

          <Item sx={{ height: `50%`, paddingBottom: '8px', overflow: 'auto' }} >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="Output" />
                <Tab label="Query" />
                {/* <Tab label="Interactive Plot" /> */}
              </Tabs>
              {value === 0 && dataset && dataset.length > 0 && (
                <button
                  style={{ background: 'none', border: 'none', padding: 0, marginLeft: 16, cursor: 'pointer', display: 'flex', alignItems: 'center', height: 36 }}
                  onClick={() => { exportToCSV(dataset, "dataworkbench_output.csv"); showSnackbar("Download successful! You have downloaded the DataWorkbench output as CSV."); }}
                  title="Download Output as CSV"
                >
                  {/* You can use a download icon here if desired */}
                  <DownloadIcon fontSize="medium" />
                </button>
              )}
            </div>
            <TabPanel value={value} index={0}>
              <SimpleTable
                key={1}
                value={value}
                data={dataset}
                query={userInput}
                // title="Granular"
                firstColumn="campaign"
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              {sqlQuery}
            </TabPanel>
            {/* <TabPanel value={value} index={2}>
              Item Three
            </TabPanel> */}
          </Item>
        </Grid>
      </Grid>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MuiAlert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default DataWorkbench;
